/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SideInfo } from './sideInfo';
import { LpPairData } from './lpPairData';

/**
 * Rate response
 */
export interface RateResponse {
  priceScale: number;
  qtyScale: number;
  totalScale: number;
  /**
   * Sell side info
   */
  sellInfo: SideInfo;
  /**
   * Buy side info
   */
  buyInfo: SideInfo;
  /**
   * LP specific pair data
   */
  lpData: Array<LpPairData>;
  /**
   * Request ID
   */
  requestId: string;
}
